import {useContext, useEffect, useMemo, useState} from 'react';
import {useNavigate, useParams, useSearchParams} from 'react-router-dom';

import {SubmissionModal} from '../../components/contest-card/submissions/ContestSubmissionModal';
import {request, URLs} from '../../api';
import AppContext from '../../context/AppContext';
import {SubmissionDetailsQueryResponse} from '../../api/responses/SubmissionEntriesResponesTypes';

export const ContestSubmissionView = () => {
  const {dispatchError} = useContext(AppContext);

  const navigate = useNavigate();
  const {submissionId, groupContest: groupContestId} = useParams();
  const [searchParams, _] = useSearchParams();

  const [submission, setSubmission] = useState<SubmissionDetailsQueryResponse | undefined>(undefined);

  useEffect(() => {
    request<never, never, SubmissionDetailsQueryResponse>(URLs.getSubmissionDetails(Number(submissionId)), {
      method: 'GET',
      successCallback(response) {
        setSubmission(response);
      },
      errorCallback() {
        dispatchError({errorMessage: 'There was an error. Please try again later.'});
      },
    });
  }, [submissionId]);

  return (
    <SubmissionModal
      submission={submission}
      onClose={() => {
        navigate({pathname: '..', search: searchParams.toString()}, {replace: true});
      }}
    />
  );
};
